var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronsRightSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.569,
    height: 16.572,
    viewBox: "0 0 16.569 16.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevrons-right-solid-2",
    d: "M32.272,41.047a1.185,1.185,0,0,1,0-1.675l7.1-7.1a1.185,1.185,0,1,1,1.675,1.675l-6.264,6.264,6.261,6.264a1.185,1.185,0,0,1-1.675,1.675l-7.1-7.1Zm14.2,7.1-7.1-7.1a1.185,1.185,0,0,1,0-1.675l7.1-7.1a1.185,1.185,0,1,1,1.675,1.675l-6.264,6.264,6.261,6.264a1.185,1.185,0,0,1-1.675,1.675Z",
    transform: "translate(-31.925 -31.925)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsRightSolid);
export default __webpack_public_path__ + "static/media/chevrons-right-solid.d83254e18a501904c29c1a315a41d1b5.svg";
export { ForwardRef as ReactComponent };